import React from 'react';

/**
 * Props for the LinkCellRenderer component
 */
export interface LinkCellRendererProps {
  value?: string;
}

/**
 * React component for rendering clickable links in AG Grid cells
 * Displays URLs as clickable hyperlinks that open in new tabs
 *
 * @param props - Component props containing the cell value
 * @returns JSX element with clickable link or null if no valid URL
 */
export const LinkCellRenderer: React.FC<LinkCellRendererProps> = ({ value }) => {
  // Return null for empty or invalid values
  if (!value || value.trim() === '') {
    return null;
  }

  return (
    <a
      href={value}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: '#0066cc',
        textDecoration: 'none',
        cursor: 'pointer',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.textDecoration = 'underline';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.textDecoration = 'none';
      }}
    >
      {value}
    </a>
  );
};

export default LinkCellRenderer;
